import { Pro } from '@/models/Pro'
import { searchWorkers } from '@/services/modules/WorkerService'
import type { PageContext } from 'vike/types'

export { data }

async function data(pageContext: PageContext): Promise<any> {
    const params = pageContext.routeParams['*'].split("/").filter(q => q !== "")

    let title = ""
    let description = ""


    switch (params.length) {
        case 0:
            title = "Trouvez un professionnel agréé sur topela";
            description = "Trouvez rapidement des professionnels et artisans qualifiés dans votre secteur. Discutez en ligne et obtenez des devis personnalisés pour votre projet."
            break;
        case 1:
            title = `Trouvez un professionnel à ${params[0]} sur topela`;
            description = `Trouvez rapidement des professionnels et artisans qualifiés à ${params[0]}. Discutez en ligne et obtenez des devis personnalisés pour votre projet.`
            break;
        case 2:
            title = `Trouvez un professionnel spécialisé en ${params[0].split('-').join(' ')} à ${params[1]} sur topela`;
            description = `Trouvez rapidement des professionnels et artisans qualifiés en ${params[0].split('-').join(' ')} à ${params[1]}. Discutez en ligne et obtenez des devis personnalisés pour votre projet.`
            break;
    }

    const pageData = {
        title: title,
        description: description,
        url: pageContext.urlPathname,
    }

    let keywordsArray: any[] = []
    let town: any = null
    let zipcode: string | null = null
    let department: any = '00'
    let platformCode: any = ''
    let shouldSearchInEntireDepartment = true

    if (params.length > 1) {
        let keywords = params[0].split("-").filter((q: string) => q !== "" && q.length > 2).slice(0, 3)
        keywordsArray = keywords
    } else if (pageContext.urlParsed.search.query) {
        let keywords = pageContext.urlParsed.search.query.split(',').filter((q: string) => q !== "")
        keywordsArray = keywords
    }

    if (params.length > 0) {
        town = params[params.length === 1 ? 0 : 1]
    } else if (pageContext.urlParsed.search.town) {
        town = pageContext.urlParsed.search.town
    }

    if (pageContext.urlParsed.search.dep) {
        department = pageContext.urlParsed.search.dep
        shouldSearchInEntireDepartment = true
    }

    if (pageContext.urlParsed.search.code) {
        platformCode = pageContext.urlParsed.search.code
    }

    if (pageContext.urlParsed.search.zipcode) {
        zipcode = pageContext.urlParsed.search.zipcode
    }

    const payload = {
        "platform_code": platformCode || null,
        "keywords": keywordsArray,
        "town": town ? removeParenthesesBlock(town) : null,
        "department": department && department !== '00' ? department : null,
        "zipcode": zipcode || null
    }

    const config = {
        params: {
            page: pageContext.urlParsed.search.page ?? 1
        }
    }

    try {

        const response = await searchWorkers(payload, config)

        return {
            ...pageData,
            workersList: response.data.items.map((item: any) => ({
                ...item,
                address: { town: item.town, zipcode: item.zipcode }
            })) as Pro[],
            count: response.data.count,
            currentPage: response.data.current_page_number,
            totalNumberOfPagesPage: response.data.total_pages,
            tagsList: keywordsArray,
            platformCode: platformCode || '',
            department: department || '00',
            town: town || null,
            zipcode: zipcode || null,
            shouldSearchInEntireDepartment,
            error: false,
            urlParams: params
        }
    } catch (err: any) {
        return {
            ...pageData,
            workersList: [],
            count: 0,
            currentPage: 1,
            totalNumberOfPagesPage: 1,
            tagsList: [],
            platformCode: '',
            department: '00',
            town: null,
            zipcode: null,
            error: true,
            urlParams: params
        }
    }
}

function removeParenthesesBlock(address: any) {
    const adr = address.replace(/\s*\(.*?\)\s*/g, '');
    return adr
}